import {
  authFetch, buildApiUrl 
} from '@/lib/api-client';
import { ApiClientError } from '@/errors';
import {
  createRequisitionResponseSchema,
  type CreateRequisitionRequest,
  type CreateRequisitionResponse,
} from '../types';

export async function createRequisition(
  siteId: string,
  request: CreateRequisitionRequest
): Promise<CreateRequisitionResponse> {
  const url = buildApiUrl(`/v1/sites/${siteId}/requisitions`);
  
  const response = await authFetch(url, {
    method: 'POST',
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    throw ApiClientError.fromResponse(response, 'Failed to create requisition');
  }

  const data: unknown = await response.json();
  return createRequisitionResponseSchema.parse(data);
}
